// src/pages/WinePage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import wineBackground from '../assets/images/wine-background.jpg';
import '../styles/wine.css';

const WinePage = () => {
  const navigate = useNavigate();

  return (
    <div className="wine-page" style={{ backgroundImage: `url(${wineBackground})` }}>
      <Header 
        title="Vins" 
        showBackButton={true} 
        onBackClick={() => navigate('/prototype-categories')}
      />
      
      <div className="wine-content">
        <div className="wine-content-overlay">
          <div className="wine-icon animate-float">
            <svg viewBox="0 0 24 24" className="w-full h-full" fill="currentColor">
              <path d="M5,3L7,3L9,3L9,10C9,11.1 9.4,12.16 10.11,12.95C10.3,13.19 10.5,13.41 10.74,13.58L8.4,18.2L8,19L16,19L15.6,18.2L13.26,13.58C13.5,13.41 13.7,13.19 13.89,12.95C14.6,12.16 15,11.1 15,10L15,3L17,3C17.55,3 18,3.45 18,4C18,4.55 17.55,5 17,5L17,7C18.66,7 20,5.66 20,4C20,2.34 18.66,1 17,1L7,1C5.34,1 4,2.34 4,4C4,5.66 5.34,7 7,7L7,5C6.45,5 6,4.55 6,4C6,3.45 6.45,3 7,3L5,3Z M13,10L11,10L11,3L13,3L13,10Z M9.5,21C9.22,21 9,21.22 9,21.5C9,21.78 9.22,22 9.5,22L14.5,22C14.78,22 15,21.78 15,21.5C15,21.22 14.78,21 14.5,21L9.5,21Z" />
            </svg>
          </div>
          
          <h2 className="wine-title">Bientôt disponible !</h2>
          
          <p className="wine-description">
            Notre cave virtuelle ouvrira ses portes prochainement. 
            Découvrez bientôt une sélection raffinée de vins rouges, blancs et rosés, 
            soigneusement choisis pour accompagner vos moments de dégustation.
          </p>
          
          <button 
            onClick={() => navigate('/prototype-categories')}
            className="wine-button"
          >
            <svg className="wine-button-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Retour aux options
          </button>
        </div>
      </div>
    </div>
  );
};

export default WinePage;